var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.featuredResources.length > 0)?_c('bbnw-resources',{attrs:{"resources":_vm.featuredResources}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }